let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dUKeO")).then(() => parcelRequire('aE3qX'));